import { FC } from 'react';
import { AdAttribute, AdStepItem } from '@/store/ad/types';

import { AttributeFormControl, PropertyFormControl } from './components';
import { StepComponents } from './config';

export type StepComponentProps = {
  stepItem: AdStepItem;
  attribute?: AdAttribute;
  parentAttribute?: AdAttribute;
  trackingAction?: string;
};

export const StepComponent: FC<StepComponentProps> = ({ stepItem, attribute, parentAttribute, trackingAction }) => {
  if (stepItem.type === 'Attribute' && attribute && attribute.editable) {
    return <AttributeFormControl stepItem={stepItem} attribute={attribute} parentAttribute={parentAttribute} />;
  }

  if (stepItem.type === 'Component' && stepItem.componentName) {
    const Component = StepComponents[stepItem.componentName];
    if (!Component) {
      console.warn(`Component ${stepItem.componentName} not found.`);
      return null;
    }
    return (
      <Component
        attribute={attribute}
        parentAttribute={parentAttribute}
        stepItem={stepItem}
        trackingAction={trackingAction}
      />
    );
  }

  if (stepItem.type === 'Property' && stepItem.attributeKey) {
    return <PropertyFormControl stepItem={stepItem} />;
  }

  return null;
};
